import { authHeader, handleResponse } from "../helper/auth-header";

export default class DashboardService {
  ControllerName = "Dashboard";

  // get GetMonthlyVerificationCountsRegionWise
  async GetMonthlyVerificationCountsRegionWise(regionId, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMonthlyVerificationCountsRegionWise?regionId=${regionId}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  // get GetWeeklyVerificationCountsRegionWise
  async GetWeeklyVerificationCountsRegionWise(regionId, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetWeeklyVerificationCountsRegionWise?regionId=${regionId}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

      // get GetUniqueMonthlyVerificationCountsRegionWise
  async GetUniqueMonthlyVerificationCountsRegionWise(regionId, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetUniqueMonthlyVerificationCountsRegionWise?regionId=${regionId}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
  // get GetUniqueWeeklyVerificationCountsRegionWise
  async GetUniqueWeeklyVerificationCountsRegionWise(regionId, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetUniqueWeeklyVerificationCountsRegionWise?regionId=${regionId}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  // get GetVerificationCounts
  async GetVerificationCounts(fromDate, toDate, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetVerificationCounts?fromDate=${fromDate}&toDate=${toDate}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  // get GetMonthlyPackingCounts
  async GetMonthlyPackingCounts(wareHouseId, brandId) {
    const requestOptions = {
      method: "GET",
      headers: authHeader()
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMonthlyPackingCounts?wareHouseId=${wareHouseId}&brandId=${brandId}`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }

  // get GetMonthlyProductActivationCounts
  async GetMonthlyProductActivationCounts(obj) {
    const requestOptions = {
      method: "POST",
      headers: authHeader(),
      body: JSON.stringify(obj)
    };
    const url = `${process.env.REACT_APP_API_URL}${this.ControllerName}/GetMonthlyProductActivationCounts`;
    const response = await fetch(url, requestOptions);
    const data = await handleResponse(response, { url, ...requestOptions });
    return data;
  }
}
